"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getElemsT = void 0;
var types_1 = require("../types.js");
function getElemsT(t) {
    // get to the first list type
    // aka, skips `alias` `asData` etc.
    while (t[0] !== types_1.PrimType.List)
        t = t[1];
    return t[1];
}
exports.getElemsT = getElemsT;
